(function(root, factory) {
  'use strict';
  const api=factory();
  if(typeof module==='object'&&module.exports)module.exports=api;
  if(root&&root.document){
    const boot=scope=>{if(scope.matches?.('[data-order-tracking]'))api.mount(scope);scope.querySelectorAll('[data-order-tracking]').forEach(api.mount);};
    if(root.document.readyState==='loading')root.document.addEventListener('DOMContentLoaded',()=>boot(root.document));else boot(root.document);
    root.document.addEventListener('shopify:section:load',event=>boot(event.target));
  }
})(typeof window!=='undefined'?window:null,function(){
  'use strict';
  function orderNumber(value){
    const text=String(value??'').trim().replace(/^#/,'');
    if(!/^\d{1,10}$/.test(text)||Number(text)<1||Number(text)>2147483647)throw Error('Enter a valid order number, for example 12345.');
    return Number(text);
  }
  function proxyPath(value){
    const path=String(value||'/apps/eliteerp-contact').replace(/\/$/,'');
    if(!/^\/(apps|a|community|tools)\/[a-zA-Z0-9_-]+$/.test(path))throw Error('Tracking is not configured. Please contact support.');
    return path+'/tracking';
  }
  function dateText(value){
    if(value===null)return 'No courier update yet';
    const match=typeof value==='string'&&value.match(/^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):\d{2}$/);
    if(!match)throw Error('Tracking response could not be confirmed.');
    const [,year,month,day,hour,minute]=match;
    if(+month<1||+month>12||+day<1||+day>31||+hour>23||+minute>59)throw Error('Tracking response could not be confirmed.');
    return `${day} ${['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'][+month-1]} ${year} · ${hour}:${minute}`;
  }
  const statuses=new Set(['Order received','Processing','Cancelled','Shipment booked','Dispatched','Delivered','Returned','Partially booked','Partially dispatched','Partially delivered','Partially returned','Cancellation pending','Status update pending','Preparing shipment','In transit','Picked up by courier','At courier warehouse','At destination facility','Out for delivery','Delivery declined','Delivery contact unsuccessful','Return in progress','Return submitted','Awaiting delivery','Awaiting return','Tracking update received']);
  function verifiedData(data,expectedOrder){
    if(!data||data.order_number!==expectedOrder||!statuses.has(data.status)||!Array.isArray(data.shipments)||data.shipment_count!==data.shipments.length)throw Error('Tracking response could not be confirmed.');
    const labels=new Set();
    for(const shipment of data.shipments){
      if(!shipment||!/^Shipment [1-9]\d*$/.test(shipment.label)||labels.has(shipment.label)||!statuses.has(shipment.status)||!Array.isArray(shipment.events))throw Error('Shipment details could not be confirmed.');
      labels.add(shipment.label);dateText(shipment.latest_update);
      for(const event of shipment.events){if(!event||!statuses.has(event.status)||event.date===null)throw Error('Shipment history could not be confirmed.');dateText(event.date);}
    }
    return data;
  }
  function retrySeconds(header,body,now=Date.now()){
    const value=header&&/^\d+$/.test(header)?Number(header):header?Math.ceil((Date.parse(header)-now)/1000):Number(body);
    if(Number.isFinite(value)&&value>0)return Math.min(900,Math.ceil(value));
    return Number.isFinite(Number(body))&&Number(body)>0?Math.min(900,Math.ceil(Number(body))):60;
  }
  async function post(path,order,fetcher,timeoutMs=20000){
    const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),timeoutMs);
    try{
      const response=await fetcher(path,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({order_number:order}),cache:'no-store',credentials:'same-origin',signal:controller.signal});
      let body;try{body=await response.json();}catch{body={};}
      if(!response.ok||body?.success!==true){
        const error=Error(response.status===429?'Please wait before checking another order.':response.status===400||response.status===404?'We could not find tracking for this order. Check the number and try again.':response.status===409?'We could not confirm this order. Please contact support.':'Tracking is temporarily unavailable. Please try again later.');
        error.status=response.status;
        if(response.status===429)error.retryAfterSeconds=retrySeconds(response.headers?.get('Retry-After'),body?.retry_after_seconds);
        throw error;
      }
      return verifiedData(body.data,order);
    }finally{clearTimeout(timer);}
  }
  function node(tag,className,text){const element=document.createElement(tag);if(className)element.className=className;if(text!==undefined)element.textContent=text;return element;}
  function renderShipments(container,shipments){
    container.replaceChildren();
    if(!shipments.length){container.append(node('p','timeline-empty','No shipments have been recorded for this order.'));return;}
    for(const shipment of shipments){
      const card=node('section','order-card shipment-card'),head=node('div','order-card-head'),title=node('h3','',shipment.label),pill=node('span','status-pill',shipment.status);
      head.append(title,pill);card.append(head,node('p','shipment-updated','Last courier update: '+dateText(shipment.latest_update)));
      const list=node('ol','timeline');list.setAttribute('aria-label',shipment.label+' history');
      if(!shipment.events.length)list.append(node('li','timeline-empty','No courier updates yet. The current shipment status is shown above.'));
      shipment.events.forEach((event,index)=>{const item=node('li','timeline-item'+(index===0?' is-current':'')),date=node('time','timeline-date',dateText(event.date));date.setAttribute('datetime',event.date);item.append(date,node('strong','timeline-status',event.status));list.append(item);});
      card.append(list);container.append(card);
    }
  }
  function mount(element){
    if(element.dataset.trackingMounted)return;element.dataset.trackingMounted='true';
    const $=selector=>element.querySelector(selector),form=$('[data-track-form]'),field=form.elements.order_number,button=$('[data-track-button]'),feedback=$('[data-message]'),result=$('[data-result]'),errorBox=$('[data-error]'),retry=$('[data-retry]');
    let path,busy=false,waitUntil=0,timer=null;
    function say(message){feedback.textContent=message;}
    function updateButtons(){const disabled=busy||Date.now()<waitUntil;button.disabled=disabled;retry.disabled=disabled;field.disabled=busy;button.textContent=busy?'Checking…':'Track order';element.setAttribute('aria-busy',String(busy));}
    function tick(){
      if(!element.isConnected){clearInterval(timer);timer=null;return;}
      const seconds=Math.max(0,Math.ceil((waitUntil-Date.now())/1000));updateButtons();
      say(seconds?`Please wait ${Math.floor(seconds/60)}:${String(seconds%60).padStart(2,'0')} before checking again.`:'You can check again now.');
      if(!seconds){clearInterval(timer);timer=null;feedback.setAttribute('aria-live','polite');}
    }
    async function track(){
      if(busy||Date.now()<waitUntil)return;
      result.hidden=true;errorBox.hidden=true;say('');let order;
      try{order=orderNumber(field.value);}catch(error){say(error.message);field.focus();return;}
      busy=true;updateButtons();
      try{
        const data=await post(path,order,window.fetch.bind(window));
        $('[data-order-number]').textContent='#'+data.order_number;$('[data-order-status]').textContent=data.status;
        $('[data-shipment-count]').textContent=data.shipment_count+' '+(data.shipment_count===1?'shipment':'shipments');
        renderShipments($('[data-shipments]'),data.shipments);result.hidden=false;result.focus();
      }catch(error){
        errorBox.hidden=false;
        $('[data-error-copy]').textContent=error.status?error.message:'We could not load tracking right now. Please try again or contact support.';
        if(error.status===429){waitUntil=Date.now()+error.retryAfterSeconds*1000;feedback.setAttribute('aria-live','off');tick();timer=setInterval(tick,1000);}
        errorBox.focus();
      }finally{busy=false;updateButtons();}
    }
    try{path=proxyPath(element.dataset.proxyPath);}catch(error){say(error.message);button.disabled=true;return;}
    form.addEventListener('submit',event=>{event.preventDefault();track();});retry.addEventListener('click',track);
  }
  return {orderNumber,proxyPath,dateText,verifiedData,retrySeconds,post,renderShipments,mount};
});
